'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var effects = require('redux-saga/effects');
var moment = require('moment');
var networkMiddleware = require('@piconetworks/network-middleware');
var menuMiddleware = require('@piconetworks/menu-middleware');
var endpoints = require('@piconetworks/endpoints');
var Duck = require('extensible-duck');
var reselect = require('reselect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);

var types = ['PURCHASE_PLAN', 'PURCHASE_PLAN_SUCCESS', 'PURCHASE_PLAN_ERROR', 'PURCHASE_PLAN_GROUP', 'PURCHASE_PLAN_GROUP_SUCCESS', 'PURCHASE_PLAN_GROUP_ERROR', 'PURCHASE_SWITCH', 'PURCHASE_SWITCH_SUCCESS', 'PURCHASE_SWITCH_ERROR', 'CANCEL_PLAN', 'CANCEL_PLAN_SUCCESS', 'CANCEL_PLAN_ERROR', 'KEEP_PLAN', 'KEEP_PLAN_SUCCESS', 'KEEP_PLAN_ERROR', 'VERIFY_DISCOUNT_CODE', 'VERIFY_DISCOUNT_CODE_SUCCESS', 'VERIFY_DISCOUNT_CODE_ERROR', 'RESET', 'CHECK_SWITCH_PLAN_NOW', 'CHECK_SWITCH_PLAN_NOW_SUCCESS', 'CHECK_SWITCH_PLAN_NOW_ERROR', 'HANDLE_DIRECT_PLAN', 'GET_PLANS', 'GET_PLANS_SUCCESS', 'GET_PLANS_ERROR'];

var creators = function creators(duck) {
  return {
    purchasePlan: function purchasePlan(payload) {
      return Object.assign({
        type: duck.types.PURCHASE_PLAN
      }, payload);
    },
    purchaseSwitch: function purchaseSwitch(payload) {
      return Object.assign({
        type: duck.types.PURCHASE_SWITCH
      }, payload);
    },
    purchasePlanGroup: function purchasePlanGroup(payload) {
      return Object.assign({
        type: duck.types.PURCHASE_PLAN_GROUP
      }, payload);
    },
    cancelPlan: function cancelPlan(payload) {
      return Object.assign({
        type: duck.types.CANCEL_PLAN
      }, payload);
    },
    keepPlan: function keepPlan(payload) {
      return Object.assign({
        type: duck.types.KEEP_PLAN
      }, payload);
    },
    verifyDiscountCode: function verifyDiscountCode(payload) {
      return Object.assign({
        type: duck.types.VERIFY_DISCOUNT_CODE
      }, payload);
    },
    reset: function reset(payload) {
      return Object.assign({
        type: duck.types.RESET
      }, payload);
    },
    checkCanSwitchPlanNow: function checkCanSwitchPlanNow(payload) {
      return Object.assign({
        type: duck.types.CHECK_SWITCH_PLAN_NOW
      }, payload);
    },
    directPlanLink: function directPlanLink(payload) {
      return Object.assign({
        type: duck.types.HANDLE_DIRECT_PLAN
      }, payload);
    },
    getPlans: function getPlans(payload) {
      return Object.assign({
        type: duck.types.GET_PLANS
      }, payload);
    }
  };
};

var initialState = {
  isFetching: false,
  isVerifyingPayment: false,
  isVerifyingPaymentSucess: null,
  isVerifyingPaymentError: null,
  isVerifyingPaymentErrorMessage: null,
  isReset: true,
  discountCodeSuccess: false,
  verifiedDiscountCode: null,
  verifiedDiscountCodeId: null,
  alternativePlans: {
    gift: {
      tiers: []
    },
    discount: {
      tiers: []
    },
    switching: {
      tiers: []
    }
  },
  canSwitchPlanNow: false,
  prorate_amount: null,
  next_price: null,
  end_date: null,
  oneTimeDonationSuccess: false
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.GET_PLANS_SUCCESS:
        if (payload.switching) {
          draftState.alternativePlans.switching = payload;
        }

        if (payload.gift) {
          draftState.alternativePlans.gift = payload;
        }

        break;

      case duck.types.GET_PLANS_ERROR:
        draftState.alternativePlans = initialState.alternativePlans;
        break;

      case duck.types.PURCHASE_PLAN:
        draftState.isVerifyingPayment = true;
        draftState.isReset = false;
        draftState.isVerifyingPaymentErrorMessage = initialState.isVerifyingPaymentErrorMessage;
        break;

      case duck.types.PURCHASE_SWITCH_SUCCESS:
      case duck.types.PURCHASE_PLAN_GROUP_SUCCESS:
      case duck.types.PURCHASE_PLAN_SUCCESS:
        draftState.isVerifyingPayment = false;
        draftState.isReset = false;

        if (payload.success) {
          draftState.isVerifyingPaymentSucess = payload.success;
          draftState.oneTimeDonationSuccess = payload.oneTimeDonationSuccess;
        }

        break;

      case duck.types.PURCHASE_SWITCH_ERROR:
      case duck.types.PURCHASE_PLAN_GROUP_ERROR:
      case duck.types.PURCHASE_PLAN_ERROR:
        draftState.isVerifyingPayment = false;
        draftState.isReset = false;

        if (payload.error) {
          draftState.isVerifyingPaymentError = payload.error;
          draftState.isVerifyingPaymentErrorMessage = error;
        }

        break;

      case duck.types.VERIFY_DISCOUNT_CODE:
        draftState.isFetching = true;
        draftState.isReset = false;
        draftState.discountCodeSuccess = false;
        break;

      case duck.types.VERIFY_DISCOUNT_CODE_SUCCESS:
        draftState.isFetching = false;
        draftState.isReset = false;
        draftState.discountCodeSuccess = true;
        draftState.verifiedDiscountCode = payload.verifiedDiscountCode;
        draftState.verifiedDiscountCodeId = payload.verifiedDiscountCodeId;
        draftState.alternativePlans.discount = payload === null || payload === void 0 ? void 0 : payload.plan;
        break;

      case duck.types.VERIFY_DISCOUNT_CODE_ERROR:
        draftState.isFetching = false;
        draftState.isReset = false;
        draftState.discountCodeSuccess = false;
        break;

      case duck.types.RESET:
        draftState.isFetching = duck.initialState.isFetching;
        draftState.isVerifyingPayment = duck.initialState.isVerifyingPayment;
        draftState.isVerifyingPaymentSucess = duck.initialState.isVerifyingPaymentSucess;
        draftState.isVerifyingPaymentError = duck.initialState.isVerifyingPaymentError;
        draftState.isReset = duck.initialState.isReset;
        draftState.discountCodeSuccess = duck.initialState.discountCodeSuccess;
        draftState.verifiedDiscountCode = duck.initialState.verifiedDiscountCode;
        draftState.verifiedDiscountCodeId = duck.initialState.verifiedDiscountCodeId;
        draftState.oneTimeDonationSuccess = duck.initialState.oneTimeDonationSuccess;
        break;

      case duck.types.CHECK_SWITCH_PLAN_NOW_SUCCESS:
        draftState.isFetching = false;
        draftState.canSwitchPlanNow = payload.canSwitchPlanNow;
        draftState.prorate_amount = payload.prorate_amount;
        draftState.next_price = payload.next_price;
        draftState.end_date = payload.end_date;
        draftState.isReset = false;
        break;

      case duck.types.HANDLE_DIRECT_PLAN:
        draftState.directPlanOptionId = payload.planOptionId;
        break;

    }
  });
};

function* cancelPlan(_ref) {
  var types = _ref.types,
      _ref$productOptionId = _ref.productOptionId,
      productOptionId = _ref$productOptionId === void 0 ? null : _ref$productOptionId,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!productOptionId) {
      throw Error('productOptionId not provided');
    }

    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'delete',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_PRODUCT(), "/").concat(productOptionId),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          discount_code_id: null,
          publisherId: publisherId
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned');
    }

    if (!data.success) {
      throw Error('create plan did not succeed');
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    var nextDate = moment__default['default'](data.purchases.current.subscription_end).format('LL');
    var goToMenuRouteAndOpenAction = yield effects.call(menuMiddleware.goToMenuRouteAndOpen, {
      menuRoute: '/notification/cancelPlan',
      backRoute: '/',
      data: {
        nextDate: nextDate
      }
    });
    yield effects.put(goToMenuRouteAndOpenAction);
    yield effects.put({
      type: types.CANCEL_PLAN_SUCCESS,
      payload: {
        success: productOptionId
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.CANCEL_PLAN_ERROR,
      error: error.message,
      payload: {
        error: productOptionId
      }
    });
  }
}

function* keepPlan(_ref) {
  var types = _ref.types,
      _ref$productOptionId = _ref.productOptionId,
      productOptionId = _ref$productOptionId === void 0 ? null : _ref$productOptionId,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
      _ref$subscriptionId = _ref.subscriptionId,
      subscriptionId = _ref$subscriptionId === void 0 ? null : _ref$subscriptionId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!productOptionId) {
      throw Error('no from id provided');
    }

    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    if (!subscriptionId) {
      throw Error('subscriptionId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'put',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_PRODUCT(), "/").concat(productOptionId),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned');
    }

    if (!data.success) {
      throw Error('create plan did not succeed');
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    var nextDate = moment__default['default'](data.purchases.current.subscription_end).format('LL');
    var goToMenuRouteAndOpenAction = yield effects.call(menuMiddleware.goToMenuRouteAndOpen, {
      menuRoute: '/notification/keepPlan',
      backRoute: '/',
      data: {
        nextDate: nextDate
      }
    });
    yield effects.put(goToMenuRouteAndOpenAction);
    yield effects.put({
      type: types.KEEP_PLAN_SUCCESS,
      payload: {
        success: productOptionId
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.KEEP_PLAN_ERROR,
      error: error.message,
      payload: {
        error: productOptionId
      }
    });
  }
}

function* purchasePlan(_ref) {
  var types = _ref.types,
      utm = _ref.utm,
      _ref$formId = _ref.formId,
      formId = _ref$formId === void 0 ? null : _ref$formId,
      _ref$articleId = _ref.articleId,
      articleId = _ref$articleId === void 0 ? null : _ref$articleId,
      _ref$productOptionId = _ref.productOptionId,
      productOptionId = _ref$productOptionId === void 0 ? null : _ref$productOptionId,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
      _ref$customPrice = _ref.customPrice,
      customPrice = _ref$customPrice === void 0 ? null : _ref$customPrice,
      _ref$newsletters = _ref.newsletters,
      newsletters = _ref$newsletters === void 0 ? null : _ref$newsletters,
      _ref$customFields = _ref.customFields,
      customFields = _ref$customFields === void 0 ? null : _ref$customFields,
      _ref$oneTimeDonation = _ref.oneTimeDonation,
      oneTimeDonation = _ref$oneTimeDonation === void 0 ? false : _ref$oneTimeDonation,
      origin = _ref.origin,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? null : _ref$source,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!formId) {
      throw Error('no form id provided');
    }

    if (!productOptionId) {
      throw Error('no product option id provided');
    }

    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_PRODUCT(), "/").concat(productOptionId),
        params: Object.assign({}, !!utm && {
          utm: utm
        }),
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        }, !!origin && {
          'current-url': origin
        }),
        timeout: 30000,
        data: Object.assign({
          article_id: articleId,
          form_id: formId
        }, customPrice && {
          custom_price: parseFloat(customPrice)
        }, newsletters && {
          newsletter_ids: newsletters
        }, customFields && {
          custom_properties: customFields
        })
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned');
    }

    if (!data.success) {
      throw Error('create plan did not succeed');
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.PURCHASE_PLAN_SUCCESS,
      payload: {
        success: productOptionId,
        oneTimeDonationSuccess: oneTimeDonation,
        source: source
      }
    });
  } catch (error) {
    var _error$errors;

    var errorMessage = (_error$errors = error.errors) !== null && _error$errors !== void 0 && _error$errors[0].custom_price ? 'Maximum purchase limit exceeded. Your product price must be less than or equal to $999,999.99.' : 'There was an issue trying to complete your purchase. Please try again or contact support if this persists.';
    yield effects.put({
      type: types.PURCHASE_PLAN_ERROR,
      error: errorMessage,
      payload: {
        error: productOptionId
      }
    });
  }
}

function* purchasePlanGroup(_ref) {
  var types = _ref.types,
      _ref$groupId = _ref.groupId,
      groupId = _ref$groupId === void 0 ? null : _ref$groupId,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!groupId) {
      throw Error('groupId not provided');
    }

    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.PURCHASE_PLAN_GROUP(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          group_id: groupId,
          publisherId: publisherId
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned');
    }

    if (!data.group || data.group.billing_status !== 'PAID') {
      throw Error('create group plan did not succeed');
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.PURCHASE_PLAN_GROUP_SUCCESS,
      payload: {
        success: groupId
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.PURCHASE_PLAN_GROUP_ERROR,
      error: error.message,
      payload: {
        error: groupId
      }
    });
  }
}

function* purchaseSwitch(_ref) {
  var types = _ref.types,
      _ref$formId = _ref.formId,
      formId = _ref$formId === void 0 ? null : _ref$formId,
      _ref$productOptionId = _ref.productOptionId,
      productOptionId = _ref$productOptionId === void 0 ? null : _ref$productOptionId,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
      _ref$customPrice = _ref.customPrice,
      customPrice = _ref$customPrice === void 0 ? null : _ref$customPrice,
      _ref$pay_now = _ref.pay_now,
      payNow = _ref$pay_now === void 0 ? null : _ref$pay_now,
      _ref$loaderInvalidati = _ref.loaderInvalidationEvent,
      loaderInvalidationEvent = _ref$loaderInvalidati === void 0 ? function () {
    return {
      type: 'LOADER_INVALIDATION_EVENT'
    };
  } : _ref$loaderInvalidati;

  try {
    if (!productOptionId) {
      throw Error('productOptionId not provided');
    }

    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_SWITCH(), "/").concat(productOptionId),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: Object.assign({
          form_id: formId,
          discount_code_id: null,
          publisherId: publisherId
        }, customPrice && {
          custom_price: customPrice
        }, payNow !== null && {
          pay_now: payNow
        })
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned');
    }

    if (!data.success) {
      throw Error('create plan did not succeed');
    }

    yield effects.put(yield effects.call(loaderInvalidationEvent, {
      payload: {
        scope: ['user']
      }
    }));
    yield effects.put({
      type: types.PURCHASE_SWITCH_SUCCESS,
      payload: {
        success: productOptionId
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.PURCHASE_SWITCH_ERROR,
      error: error.message,
      payload: {
        error: productOptionId
      }
    });
  }
}

function* verifyDiscountCode(_ref) {
  var types = _ref.types,
      code = _ref.code,
      publisherId = _ref.publisherId;

  try {
    var _data$plan;

    if (!code) {
      throw Error('discount code must be provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PLANS_DISCOUNT(), "/").concat(code),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        params: {
          publisherId: publisherId
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data.is_valid) {
      throw Error('Invalid discount code');
    }

    if (!(data !== null && data !== void 0 && (_data$plan = data.plan) !== null && _data$plan !== void 0 && _data$plan.tiers)) {
      throw Error('Unable to read new tiers');
    }

    yield effects.put({
      type: types.VERIFY_DISCOUNT_CODE_SUCCESS,
      payload: {
        verifiedDiscountCodeId: data.discount_code_id,
        verifiedDiscountCode: code,
        plan: data.plan
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.VERIFY_DISCOUNT_CODE_ERROR,
      error: error.message
    });
  }
}

function* checkCanSwitchPlanNow(_ref) {
  var types = _ref.types,
      _ref$productOptionId = _ref.productOptionId,
      productOptionId = _ref$productOptionId === void 0 ? null : _ref$productOptionId,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId;

  try {
    if (!productOptionId) {
      throw Error('productOptionId not provided');
    }

    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: "".concat(endpoints.PURCHASE_SWITCH(), "/").concat(productOptionId),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        params: {
          product_option_id: productOptionId
        }
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('Check switch plan now did not succeed. No data returned');
    }

    yield effects.put({
      type: types.CHECK_SWITCH_PLAN_NOW_SUCCESS,
      payload: {
        canSwitchPlanNow: data.pay_now,
        prorate_amount: data.prorate_amount,
        next_price: data.next_price,
        end_date: data.end_date
      }
    });
  } catch (error) {
    console.log(error);
    yield effects.put({
      type: types.CHECK_SWITCH_PLAN_NOW_ERROR,
      error: error.message,
      payload: {
        error: productOptionId
      }
    });
  }
}

function* getPlans(_ref) {
  var types = _ref.types,
      _ref$publisherId = _ref.publisherId,
      publisherId = _ref$publisherId === void 0 ? null : _ref$publisherId,
      gift = _ref.gift,
      switching = _ref.switching;

  try {
    if (!publisherId) {
      throw Error('publisherId not provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.USERS_PLAN(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000
      }
    }),
        data = _yield$putResolve.data;

    if (!data) {
      throw Error('no data returned');
    }

    var payload = Object.assign({}, data, {
      gift: gift,
      switching: switching
    });
    yield effects.put({
      type: types.GET_PLANS_SUCCESS,
      payload: payload
    });
  } catch (error) {
    yield effects.put({
      type: types.GET_PLANS_ERROR,
      error: error.message
    });
  }
}

var sagas = function sagas(duck) {
  return {
    cancelPlan: function* cancelPlan$1(payload) {
      yield cancelPlan(Object.assign({}, payload, duck));
    },
    keepPlan: function* keepPlan$1(payload) {
      yield keepPlan(Object.assign({}, payload, duck));
    },
    purchasePlan: function* purchasePlan$1(payload) {
      yield purchasePlan(Object.assign({}, payload, duck));
    },
    purchasePlanGroup: function* purchasePlanGroup$1(payload) {
      yield purchasePlanGroup(Object.assign({}, payload, duck));
    },
    purchaseSwitch: function* purchaseSwitch$1(payload) {
      yield purchaseSwitch(Object.assign({}, payload, duck));
    },
    verifyDiscountCode: function* verifyDiscountCode$1(payload) {
      yield verifyDiscountCode(Object.assign({}, payload, duck));
    },
    checkCanSwitchPlanNow: function* checkCanSwitchPlanNow$1(payload) {
      yield checkCanSwitchPlanNow(Object.assign({}, payload, duck));
    },
    getPlans: function* getPlans$1(payload) {
      yield getPlans(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.VERIFY_DISCOUNT_CODE, sagas.verifyDiscountCode), effects.takeEvery(types.PURCHASE_PLAN, sagas.purchasePlan), effects.takeEvery(types.PURCHASE_PLAN_GROUP, sagas.purchasePlanGroup), effects.takeEvery(types.PURCHASE_SWITCH, sagas.purchaseSwitch), effects.takeEvery(types.CANCEL_PLAN, sagas.cancelPlan), effects.takeEvery(types.KEEP_PLAN, sagas.keepPlan), effects.takeEvery(types.CHECK_SWITCH_PLAN_NOW, sagas.checkCanSwitchPlanNow), effects.takeEvery(types.GET_PLANS, sagas.getPlans)];
};

var selectors = function selectors() {
  return {
    plan: new Duck__default['default'].Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.plan;
      };
    }),
    isVerifyingPayment: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.plan, function (_ref) {
        var isVerifyingPayment = _ref.isVerifyingPayment;
        return isVerifyingPayment;
      });
    }),
    isVerifyingPaymentSucess: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.plan, function (_ref2) {
        var isVerifyingPaymentSucess = _ref2.isVerifyingPaymentSucess;
        return isVerifyingPaymentSucess;
      });
    }),
    isVerifyingPaymentError: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.plan, function (_ref3) {
        var isVerifyingPaymentError = _ref3.isVerifyingPaymentError;
        return isVerifyingPaymentError;
      });
    }),
    isVerifyingPaymentErrorMessage: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.plan, function (_ref4) {
        var isVerifyingPaymentErrorMessage = _ref4.isVerifyingPaymentErrorMessage;
        return isVerifyingPaymentErrorMessage;
      });
    }),
    isOneTimeDonationSuccess: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.plan, function (_ref5) {
        var oneTimeDonationSuccess = _ref5.oneTimeDonationSuccess;
        return oneTimeDonationSuccess;
      });
    }),
    switchNow: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.plan, function (_ref6) {
        var canSwitchPlanNow = _ref6.canSwitchPlanNow,
            prorate_amount = _ref6.prorate_amount,
            next_price = _ref6.next_price,
            end_date = _ref6.end_date;
        return canSwitchPlanNow && {
          canSwitchPlanNow: canSwitchPlanNow,
          prorate_amount: prorate_amount,
          next_price: next_price,
          end_date: end_date
        };
      });
    })
  };
};

var storeDefault = 'plan';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      _ref$selectors = _ref.selectors,
      selectors$1 = _ref$selectors === void 0 ? selectors : _ref$selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors$1
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
